var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Empty',[_c('img',{attrs:{"slot":"image","src":require("@/assets/image/empty.png"),"alt":""},slot:"image"}),_c('template',{slot:"description"},[_vm._t("description",function(){return [_vm._v("暂无数据")]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }